import { useFlag } from 'react-tggl-client'

export function useIsBookingEnabled() {
  const { value: isBookingEnabled, loading: isFlagLoading } = useFlag('sms-appointment-booking', false)

  return {
    isBookingEnabled: Boolean(isBookingEnabled),
    isFlagLoading,
  }
}
